<template>
    <v-btn class="disable-button-active" color="primary" depressed :to="{ name: 'AuthLogin'}" exact v-if="!loggedIn">
        Login
        <v-icon>mdi-login</v-icon>
    </v-btn>

    <v-btn @click="logout" depressed color="primary" v-else>
        Logout
        <v-icon>mdi-logout</v-icon>
    </v-btn>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: "Utility-LoginLogoutButton",
        data: () => ({
        }),

        created(){
            this.checkUserState();
        },
        computed: {
            loggedIn() {
                return this.$store.getters['user/loggedIn'];
            }
        },
        methods: {
            ...mapActions({
               checkUserState: 'user/setLoggedInState'
            }),
            logout(){
                this.$store.dispatch('user/logoutUser')
                .then(() => {
                    this.$router.push({name: 'AuthLogin'});
                })
            }
        }
    }
</script>

<style scoped>

</style>